import { useCallback } from 'react';

import { useUploadEbookSubmissionMutation } from '../core/graphql/operation-hooks';
import { PintoUploadEbookSubmissionInput } from '../core/graphql/types';

const useMutationUploadEbookSubmission = () => {
  const [mutateUploadEbookSubmission, { loading: isLoadingMutateUploadEbookSubmission }] = useUploadEbookSubmissionMutation({ errorPolicy: 'all' });

  const onMutateUploadEbookSubmission = useCallback(
    async (input: PintoUploadEbookSubmissionInput) => {
      const variables = { input };
      const res = await mutateUploadEbookSubmission({ variables });
      if (res.errors) {
        return { success: false as const, errors: res.errors };
      }
      return { success: true as const, ebookSubmission: res.data?.uploadEbookSubmission };
    },
    [mutateUploadEbookSubmission],
  );

  return {
    onMutateUploadEbookSubmission,
    isLoadingMutateUploadEbookSubmission,
  };
};

export default useMutationUploadEbookSubmission;
